import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 단일 후원 버튼 컴포넌트
 * 모바일: 토스 앱으로 바로 이동
 * 데스크톱: QR 코드 모달 표시
 */
export const DonationButton = ({ amount, label, onDonate, className = '', }) => {
    const finalAmount = amount ?? 5000;
    const BANK_CODE = '케이뱅크'; // 케이뱅크
    const ACCOUNT_NO = '100103752030';
    const ACCOUNT_HOLDER = '유형찬';
    const createTossLink = (donationAmount) => {
        const message = encodeURIComponent('후원 감사합니다!');
        const encodedBank = encodeURIComponent(BANK_CODE);
        const finalAmount = donationAmount ?? 5000;
        // 토스 딥링크 형식: supertoss://send?bank={은행코드}&account={계좌번호}&amount={금액}&message={메시지}
        return `supertoss://send?amount=${finalAmount}&bank=${encodedBank}&accountNo=${ACCOUNT_NO}&msg=${message}&origin=qr`;
    };
    const isMobile = () => {
        return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    };
    const openQRWindow = () => {
        try {
            // 새 창 열기
            const qrWindow = window.open('', 'qrcode', 'width=520,height=700,menubar=no,toolbar=no,location=no');
            if (!qrWindow) {
                alert('팝업 차단이 활성화되어 있습니다. 팝업을 허용해주세요.');
                return;
            }
            // 이미지 경로 (현재 도메인 기반)
            // HTML 작성
            const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>후원 - QR 코드</title>
          <style>
            * { margin: 0; padding: 0; box-sizing: border-box; }
            body {
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              min-height: 100vh;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 20px;
            }
            .container {
              background: white;
              border-radius: 24px;
              padding: 32px 24px;
              box-shadow: 0 20px 60px rgba(0,0,0,0.3);
              width: 100%;
              max-width: 420px;
            }
            .header {
              text-align: center;
              margin-bottom: 28px;
            }
            h1 {
              font-size: 22px;
              color: #1a1a1a;
              margin-bottom: 8px;
              font-weight: 700;
            }
            .subtitle {
              color: #666;
              font-size: 13px;
              line-height: 1.5;
            }
            .qr-wrapper {
              display: flex;
              justify-content: center;
              margin-bottom: 28px;
            }
            .qr-box {
              background: #f5f5f5;
              padding: 16px;
              border-radius: 12px;
              border: 1px solid #e0e0e0;
            }
            .qr-box img {
              display: block;
              width: 300px;
              height: 300px;
              border-radius: 8px;
            }
            .amount-box {
              background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
              color: white;
              padding: 18px;
              border-radius: 12px;
              margin-bottom: 20px;
              text-align: center;
            }
            .amount-label {
              font-size: 11px;
              opacity: 0.9;
              margin-bottom: 6px;
              font-weight: 500;
            }
            .amount-value {
              font-size: 28px;
              font-weight: 700;
            }
            .account-section {
              background: #f8f9fa;
              padding: 18px;
              border-radius: 12px;
              margin-bottom: 20px;
            }
            .account-label {
              font-size: 11px;
              color: #888;
              margin-bottom: 12px;
              text-align: center;
              font-weight: 600;
            }
            .account-box {
              background: white;
              padding: 12px 14px;
              border-radius: 8px;
              display: flex;
              gap: 10px;
              align-items: center;
            }
            .account-info {
              flex: 1;
            }
            .account-number {
              font-family: 'Courier New', monospace;
              font-size: 14px;
              font-weight: 700;
              color: #1a1a1a;
              margin-bottom: 2px;
            }
            .account-detail {
              font-size: 11px;
              color: #888;
            }
            .copy-btn {
              flex-shrink: 0;
              padding: 8px 12px;
              background: #667eea;
              color: white;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              font-size: 12px;
              font-weight: 600;
              transition: background 0.2s;
              white-space: nowrap;
            }
            .copy-btn:hover {
              background: #5568d3;
            }
            .copy-btn:active {
              background: #4558c3;
            }
            .button-group {
              display: flex;
              gap: 8px;
            }
            .close-btn {
              flex: 1;
              padding: 10px;
              background: #e8e8e8;
              border: none;
              border-radius: 8px;
              cursor: pointer;
              font-size: 14px;
              color: #333;
              font-weight: 600;
              transition: background 0.2s;
            }
            .close-btn:hover {
              background: #d8d8d8;
            }
            .print-btn {
              flex: 1;
              padding: 10px;
              background: #667eea;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: pointer;
              font-size: 14px;
              font-weight: 600;
              transition: background 0.2s;
            }
            .print-btn:hover {
              background: #5568d3;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <div class="header">
              <h1>💝 후원하기</h1>
              <p class="subtitle">모바일에서 QR 코드를<br>스캔해주세요</p>
            </div>

            <div class="qr-wrapper">
              <div class="qr-box">
                <img src="data:image/png;base64,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" alt="QR Code" />
              </div>
            </div>

            ${amount !== null && amount !== undefined
                ? `
            <div class="amount-box">
              <div class="amount-label">요청 금액</div>
              <div class="amount-value">${finalAmount.toLocaleString()}원</div>
            </div>
            `
                : ''}

            <div class="account-section">
              <div class="account-label">또는 계좌번호로 송금</div>
              <div class="account-box">
                <div class="account-info">
                  <div class="account-number">${ACCOUNT_NO}</div>
                  <div class="account-detail">케이뱅크 | ${ACCOUNT_HOLDER}</div>
                </div>
                <button class="copy-btn" onclick="copyAccount()">복사</button>
              </div>
            </div>

            <div class="button-group">
              <button class="close-btn" onclick="window.close()">닫기</button>
              <button class="print-btn" onclick="window.print()">인쇄</button>
            </div>
          </div>

          <script>
            function copyAccount() {
              const accountNumber = '${ACCOUNT_NO}';
              navigator.clipboard.writeText(accountNumber).then(() => {
                const btn = event.target;
                const originalText = btn.textContent;
                btn.textContent = '✓ 복사됨';
                setTimeout(() => {
                  btn.textContent = originalText;
                }, 1500);
              }).catch(err => {
                console.error('복사 실패:', err);
                alert('계좌번호: ${ACCOUNT_NO}');
              });
            }
          </script>
        </body>
        </html>
      `;
            qrWindow.document.write(htmlContent);
            qrWindow.document.close();
        }
        catch (error) {
            console.error('QR 코드 창 열기 실패:', error);
            alert('QR 코드를 표시할 수 없습니다. 다시 시도해주세요.');
        }
    };
    const handleClick = () => {
        onDonate?.(amount ?? null);
        if (isMobile()) {
            // 모바일: 토스 앱 바로 실행
            window.location.href = createTossLink(amount ?? null);
            // 3초 후 앱이 안열리면 설치 페이지로
            setTimeout(() => {
                if (document.visibilityState === 'visible') {
                    window.location.href = 'https://toss.im/app';
                }
            }, 3000);
        }
        else {
            // 데스크톱: 새로운 창에서 QR코드 표시
            openQRWindow();
        }
    };
    const displayLabel = label || `${finalAmount.toLocaleString()}원 후원`;
    return (_jsx("button", { onClick: handleClick, className: `inline-flex items-center justify-center px-6 py-3 text-base font-semibold rounded-lg border-2 border-blue-600 bg-white text-blue-600 transition-all duration-200 hover:bg-blue-600 hover:text-white hover:-translate-y-0.5 active:translate-y-0 ${className}`, children: displayLabel }));
};
export default DonationButton;
